import { defineMessages } from "react-intl";

const messages = defineMessages({
    name: {
        description: "Label for name input",
        defaultMessage: "Your name"
    },
    email: {
        description: "Label for email input",
        defaultMessage: "Business email"
    },
    emailPlaceholder: {
        description: "Label for email placeholder",
        defaultMessage: "e.g. you@company.com"
    },
    namePlaceholder: {
        description: "Placeholder for name input",
        defaultMessage: "e.g. Jane Smith"
    },
    passwordPlaceholder: {
        description: "Placeholder for password input",
        defaultMessage: "Min. 12 characters"
    },
    password: {
        description: "Label for password input",
        defaultMessage: "Password"
    },
    confirmPassword: {
        description: "Label for confirm password input",
        defaultMessage: "Confirm Password"
    },
    confirmPasswordPlaceholder: {
        description: "Placeholder for confirm password input",
        defaultMessage: "Re-enter your password"
    },
    showPassword: {
        description: "Tooltip and aria-label for show password button",
        defaultMessage: "Show password"
    },
    hidePassword: {
        description: "Tooltip and aria-label for hide password button",
        defaultMessage: "Hide password"
    },
    buttonSignUp: {
        description: "Button Sign Up",
        defaultMessage: "Sign up"
    }
});

export default messages;
